export default __webpack_public_path__ + "static/Mitsubishi Outlander-883414d5e125a7e4b4c686fdc863cf50.jpg";